// extracted by mini-css-extract-plugin
module.exports = {"editContainer":"datasources-module__editContainer___1dlTD"};